import { render, staticRenderFns } from "./VipUserModalCreate.vue?vue&type=template&id=27bf7158"
import script from "./VipUserModalCreate.vue?vue&type=script&lang=js"
export * from "./VipUserModalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports